import { SET_CURRENT_MODAL } from "@/store/mutation-types";

import eventBus from "@/services/EventBus";

let modalResolver = null;

export default {
  open({ commit, dispatch, state }, modal) {
    if (typeof modal === "string") {
      modal = {
        name: modal,
        data: null
      };
    }

    const { name, data } = modal;

    return new Promise(resolve => {
      if (state.name === name) {
        resolve();
      } else {
        if (state.name) {
          dispatch("close");
        }

        commit(SET_CURRENT_MODAL, { name, data });

        eventBus.$emit("page:lock");

        modalResolver = resolve;
      }
    });
  },
  close({ commit }, data = {}) {
    commit(SET_CURRENT_MODAL, null);

    eventBus.$emit("page:unlock");

    if (modalResolver) {
      modalResolver(data);
      modalResolver = null;
    }
  }
};
